
import Dashboard from './components/Dashboard';
function App() {
  return (
    <div>
      <Dashboard></Dashboard>
    </div>
  );
}
export default App;
